import Table from '../Table';
import { AsyncDataGridContext } from './context';
class AsyncTable extends Table {}
AsyncTable.contextType = AsyncDataGridContext;
export default AsyncTable;